import { Injectable } from '@angular/core';
import type { CompanyGroupFindInterface } from '@zaoblako/shared/modules/client/dtos/company.group/company-group-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyGroupService extends BaseService {
  protected baseUrl = '/basis/client/company-group';

  public getMy(): Observable<CompanyGroupFindInterface[]> {
    return this.http.get<CompanyGroupFindInterface[]>(`${this.baseUrl}/my`);
  }
}
